export const Order_Status = {
  PAID: "paid",
  NOT_PAID: "not_paid",
  PENDING: "pending"
};